import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { PromptService, Prompt } from '@services/prompt.service';
import { PromptEditComponent } from './prompt-edit/prompt-edit.component';

@Component({
    selector: 'app-prompt',
    templateUrl: './prompt.component.html',
    styleUrls: ['./prompt.component.css']
})
export class PromptComponent implements OnInit {
    prompts: Prompt[] = [];
    loading = false;
    searchTerm = '';

    constructor(
        private promptService: PromptService,
        private toastr: ToastrService,
        private modalService: NgbModal
    ) {}

    ngOnInit(): void {
        this.loadPrompts();
    }

    loadPrompts(): void {
        this.loading = true;
        this.promptService.getAll().subscribe({
            next: (data) => {
                this.prompts = data;
                this.loading = false;
            },
            error: () => {
                this.toastr.error('Promptlar yüklenirken hata oluştu', 'Hata');
                this.loading = false;
            }
        });
    }

    get filteredPrompts(): Prompt[] {
        if (!this.searchTerm) return this.prompts;
        const term = this.searchTerm.toLowerCase();
        return this.prompts.filter(p =>
            p.name.toLowerCase().includes(term) ||
            p.systemPrompt.toLowerCase().includes(term)
        );
    }

    openCreateModal(): void {
        const modalRef = this.modalService.open(PromptEditComponent, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.isEditMode = false;
        modalRef.result.then(
            (result) => { if (result) this.loadPrompts(); },
            () => {}
        );
    }

    openEditModal(prompt: Prompt): void {
        const modalRef = this.modalService.open(PromptEditComponent, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.isEditMode = true;
        modalRef.componentInstance.promptData = prompt;
        modalRef.result.then(
            (result) => { if (result) this.loadPrompts(); },
            () => {}
        );
    }

    deletePrompt(prompt: Prompt): void {
        if (confirm(`"${prompt.name}" promptunu silmek istediğinize emin misiniz?`)) {
            this.promptService.delete(prompt.id!).subscribe({
                next: () => {
                    this.toastr.success('Prompt başarıyla silindi', 'Başarılı');
                    this.loadPrompts();
                },
                error: () => {
                    this.toastr.error('Prompt silinirken hata oluştu', 'Hata');
                }
            });
        }
    }
}
